import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { deleteRow, listCollection, saveRow, type Row } from '../../lib/db';
import { sortByOrder } from '../../lib/order';
import { OrderInput } from '../../components/OrderInput';
import { useToast } from '../../components/Toast';

const collectionFor = (kind?: string) =>
  kind === 'candidate' ? 'candidateTestimonials' : 'businessPartnerTestimonials';

export function TestimonialList() {
  const { kind } = useParams();
  const col = collectionFor(kind);
  const [rows, setRows] = useState<Row[]>([]);
  const [loading, setLoading] = useState(true);
  const { notify } = useToast();

  const load = () =>
    listCollection(col, 'createdAt').then((r) => {
      setRows(sortByOrder(r));
      setLoading(false);
    });
  useEffect(() => {
    setLoading(true);
    void load();
  }, [col]);

  const remove = async (id: string) => {
    if (!confirm('Delete this testimonial?')) return;
    await deleteRow(col, id);
    notify('success', 'Deleted.');
    void load();
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="fw-bold m-0">
          {kind === 'candidate' ? 'Candidate' : 'Business partner'} testimonials
        </h3>
        <Link to={`/testimonials/${kind}/new`} className="btn btn-success btn-sm">
          New testimonial
        </Link>
      </div>
      {loading ? (
        <p className="text-muted">Loading…</p>
      ) : (
        <table className="table table-hover">
          <thead>
            <tr>
              <th>Order</th>
              <th>Name (BG)</th>
              <th>Position (BG)</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const name = (r.name ?? {}) as { bg?: string };
              const pos = (r.position ?? {}) as { bg?: string };
              return (
                <tr key={r.id}>
                  <td>
                    <OrderInput
                      value={typeof r.order === 'number' ? r.order : undefined}
                      onSave={async (n) => {
                        await saveRow(col, r.id, { order: n });
                        void load();
                      }}
                    />
                  </td>
                  <td>{name.bg}</td>
                  <td>{pos.bg}</td>
                  <td className="text-end">
                    <Link
                      to={`/testimonials/${kind}/${r.id}`}
                      className="btn btn-sm btn-outline-secondary me-2"
                    >
                      Edit
                    </Link>
                    <button className="btn btn-sm btn-outline-danger" onClick={() => remove(r.id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </>
  );
}
